import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  InputBase,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useForm } from "../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { NumberInput } from "../NumberInput";
import { unSelectReservation } from "../../../store/reservation/reservationSlice";
import { fetchData } from "../../helpers/getData/fetchData";
import { editReservationByAdmin } from "../../helpers/reservation";
import { style } from "../../../helpers/editStyle";

export const EditReservation = ({ setHidden, setReloadData, vehiclesList }) => {
  const { t } = useTranslation("global");
  const [nameList, setNameList] = useState("isLoading");
  const [myName, setMyName] = useState("isLoading");
  const { dataToAction } = useSelector((state) => state.reservation);

  const dispatch = useDispatch();
  const intentionResp =
    dataToAction.intention === "No reserva" ||
    dataToAction.intention === "No reservation"
      ? "No"
      : "Si";
  const [formValues, handleInputChange, reset] = useForm({
    ...dataToAction,
    intention: intentionResp,
  });

  const { intention, amount, whoInvests, comments, vehicle } = formValues;

  const handleCancel = () => {
    reset();
    dispatch(unSelectReservation());
    setHidden(false);
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    const intentionResp =
      intention === "No" ? "No reserva" : "Reserva realizada";
    await editReservationByAdmin(
      { ...formValues, intention: intentionResp },
      t("reservation.successMsgEdit"),
      t("reservation.errorMsg"),
      dispatch
    );
    setReloadData((prevState) => !prevState);
    setHidden(false);
  };

  useEffect(() => {
    fetchData(
      setNameList,
      `/companies/listNameQuery?name=${dataToAction.individualId}`,
      t
    );
    fetchData(
      setMyName,
      `/user/getOneName?number=${dataToAction.individualId}`,
      t
    );
  }, [t, dataToAction.individualId]);

  return (
    <>
      {nameList !== "isLoading" && myName !== "isLoading" && (
        <Modal
          open={true}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ zIndex: 9999 }}
        >
          <Box sx={style}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="baseline"
              sx={{ height: "50px" }}
            >
              <Typography
                color="primary"
                marginBottom="10px"
                variant="h5"
                fontWeight={700}
              >
                {t("reservation.editReservation")}
              </Typography>
              <IconButton color="primary" onClick={handleCancel}>
                <CloseRoundedIcon />
              </IconButton>
            </Stack>
            <form
              onSubmit={onSubmit}
              style={{
                padding: "10px 5px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
              }}
            >
              <Stack
                sx={{
                  height: "calc(70vh - 200px)",
                  overflowY: "auto",
                  paddingBottom: "10px",
                  paddingRight: "20px",
                }}
              >
                <Grid container direction="row" width="100%">
                  <Grid item xs={12} padding="0 5px">
                    <Typography variant="overline" color="secondary">
                      {t("reservation.intention")}
                    </Typography>
                    <Autocomplete
                      disablePortal
                      options={["Si", "No"]}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          name="intention"
                        />
                      )}
                      value={intention}
                      onSelect={handleInputChange}
                      required
                    />
                  </Grid>
                </Grid>

                {intention === "Si" && (
                  <>
                    <Grid container direction="row" width="100%">
                      <Grid item xs={12} padding="0 5px">
                        <Typography variant="overline" color="secondary">
                          {t("reservation.whoInvests")}
                        </Typography>
                        <Autocomplete
                          disablePortal
                          options={[
                            ...nameList,
                            `${myName.name} ${myName.surnames}`,
                          ]}
                          size="small"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              name="whoInvests"
                            />
                          )}
                          value={whoInvests}
                          onSelect={handleInputChange}
                          required
                        />
                      </Grid>
                    </Grid>

                    <Grid container direction="row" width="100%">
                      <Grid item xs={12} padding="0 5px">
                        <NumberInput
                          name={amount}
                          title="amount"
                          handleInputChange={handleInputChange}
                          min={2000}
                        />
                      </Grid>
                    </Grid>

                    <Grid container direction="row" width="100%">
                      <Grid item xs={12} padding="0 5px">
                        <Typography variant="overline" color="secondary">
                          {t("addevent.comments")}
                        </Typography>
                        <InputBase
                          fullWidth
                          name="comments"
                          size="small"
                          variant="standard"
                          value={comments}
                          onChange={handleInputChange}
                          type="text"
                          multiline
                        />
                      </Grid>
                    </Grid>

                    <Stack direction="column" width="100%" gap={0}>
                      <Typography variant="overline" color="secondary">
                        {t("opportunities.vehicle")}
                      </Typography>
                      <Autocomplete
                        disablePortal
                        options={vehiclesList}
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            name="vehicle"
                          />
                        )}
                        value={vehicle}
                        onSelect={handleInputChange}
                        fullWidth
                        required
                      />
                    </Stack>
                  </>
                )}
              </Stack>

              <Stack sx={{ heigth: "80px" }}>
                <Divider sx={{ margin: "30px 0px 15px 0px" }} />

                <Grid container direction="row" width="100%">
                  <Grid item xs={12} md={6} padding="0 5px">
                    <Button fullWidth onClick={handleCancel} variant="text">
                      {t("createPassword.cancelButton")}
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={6} padding="0 5px">
                    <Button fullWidth type="submit" variant="contained">
                      {t("createPassword.principalButton")}
                    </Button>
                  </Grid>
                </Grid>
              </Stack>
            </form>
          </Box>
        </Modal>
      )}
    </>
  );
};
